export const TAX_INCOME_OPTIONS = [
  {
    label: 'Salary Income',
    value: 'salary_income',
  },
  {
    label: 'Interest Income',
    value: 'interest_income',
  },
  {
    label: 'Dividend Income',
    value: 'dividend_income',
  },
  {
    label: 'Property Rental Income',
    value: 'property_rental_income',
  },
  {
    label: 'Capital Gains',
    value: 'capital_gains',
  },
  {
    label: 'Other Income',
    value: 'other_income',
  },
  {
    label: 'None',
    value: 'none',
  },
];
